export const verifyAuth = () =>
  fetch(process.env.REACT_APP_LOGIN_VERIFY_API as string, { credentials: 'include' });
